import { Box, Paper, Typography } from '@mui/material'
import { Button } from '@ds/components'
import { useNavigate } from 'react-router'
import { INVALID_TOKEN_VIEW_STRINGS } from './strings'

type TInvalidTokenViewProps = {
  onBackToLogin: () => void
}

export const InvalidTokenView = ({ onBackToLogin }: TInvalidTokenViewProps) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pt: { xs: 12, sm: 8, md: 6 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4, md: 5 },
          minWidth: { xs: '90%', sm: 400, md: 480 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          bgcolor: 'background.default',
        }}
      >
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 500, color: 'error.main' }}>
          {INVALID_TOKEN_VIEW_STRINGS.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          {INVALID_TOKEN_VIEW_STRINGS.description}
        </Typography>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => navigate('/forgot-password')}
            sx={{ py: 1.5 }}
          >
            {INVALID_TOKEN_VIEW_STRINGS.requestNewResetButton}
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={onBackToLogin}
            sx={{ color: 'text.primary' }}
          >
            {INVALID_TOKEN_VIEW_STRINGS.backToLoginButton}
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
